exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--form-color:#fff;--font-color:#000}.color-style{height:50px!important}.box-text-color{margin:auto;font-size:20px;text-align:center;cursor:pointer}.box-01{color:var(--font-color);background-color:var(--form-color)}.box-01,.box-02{padding:6px;border:2px solid #000}.box-02{color:var(--form-header-text-color);background-color:var(--form-header-color)}", ""]);

// exports
